import './brokerIABanner.scss';

// @vendors
import React from 'react';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

// @helpers
import { i18n } from 'core/i18n';

// @utilities
import { recordCommercialSpaceV2 } from 'utilities/tagging';

// @constants
import {
    COMMERCIAL_ADS_ACTION_EVENT,
    COMMERCIAL_ADS_AI_ID,
    COMMERCIAL_ADS_EVENT_CATEGORY,
} from 'constants/tagging';

const BrokerIABanner = ({
    titleKey = 'brokerIA-brokerIA',
    subtitleKey = 'brokerIA-detail_slide',
    buttonKey = 'brokerIA-know_more',
    type,
    extraClass,
    callMeBackEnabled
}) => {
    const { formatText } = i18n;
    const className = classNames('brokerIA-banner', extraClass, {
        'brokerIA-banner--pgo-exo': type === 'pgo-exo',
        'brokerIA-banner--search-results': type === 'search-results',
        'brokerIA-banner--call-me-back': callMeBackEnabled
    });

    const doTaggingForCommercialAdsClick = () => {
        recordCommercialSpaceV2({
            accionEvento: COMMERCIAL_ADS_ACTION_EVENT,
            categoriaEvento: COMMERCIAL_ADS_EVENT_CATEGORY + COMMERCIAL_ADS_AI_ID,
        });
    };

    return (
        <div className={className}>
            <div className="brokerIA-banner__content">
                <h2 className="brokerIA-banner__title">{formatText(titleKey)}</h2>
                <p className="brokerIA-banner__text">{formatText(subtitleKey)}</p>
            </div>

            <Link
                className="brokerIA-banner__link"
                to={'/myprofile/broker/broker-artificial-intelligence'}
                onClick={doTaggingForCommercialAdsClick}
            >
                <strong>{formatText(buttonKey)}</strong>
            </Link>
        </div>
    );
};

BrokerIABanner.propTypes = {
    titleKey: PropTypes.string.isRequired,
    subtitleKey: PropTypes.string.isRequired,
    buttonKey: PropTypes.string,
    type: PropTypes.oneOf(['pgo-exo', 'search-results'].isRequired),
    extraClass: PropTypes.string,
};

export default BrokerIABanner;
